module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-download-small-8930791a7ec279f7cb2d3479bff1b265.png";